<template>
  <div
    id="footer"
    class="bg-white dark:bg-dark-surface relative z-30 w-full px-4 py-8 md:px-12 flex flex-col md:flex-row flex-wrap justify-between border-t-0.5 border-grey-11 dark:border-dark-border"
  >
    <div class="footer-logo h-full md:order-first w-full mb-2">
      <AppLabourLogo fill="#666666" />
    </div>
    <div class="order-3 md:order-first max-w-full md:max-w-[60%]">
      <p class="text-grey-4 dark:text-dark-ink-muted text-sm mt-2 md:mt-4">
        Promoted by Joe Fortune on behalf of the Labour Party, both at Labour
        Central, Kings Manor, Newcastle, NE1 6PA.
      </p>
      <p class="text-grey-4 dark:text-dark-ink-muted text-sm mt-2 md:mt-4">
        Copyright ©{{ year }} Labour All rights reserved.
      </p>
      <ul class="text-grey-4 dark:text-dark-ink-muted text-sm mt-2 md:mt-4 flex flex-wrap">
        <li class="mr-4">
          <a
            href="https://labour.org.uk/terms-and-conditions/"
            class="hover:underline hover:text-red-1"
            >Terms and Conditions</a
          >
        </li>
        <li class="mr-4">
          <a
            href="https://labour.org.uk/privacy/privacy-notices/volunteers-privacy-notice/"
            class="hover:underline hover:text-red-1"
            >Privacy</a
          >
        </li>
        <li>
          <a
            class="hover:underline hover:text-red-1"
            href="https://labour.org.uk/cookie-policy/"
            >Cookie Policy</a
          >
        </li>
      </ul>
    </div>
    <div class="items-center flex order-2 md:order-first my-3.5 md:my-0">
      <ul class="flex">
        <li
          v-for="social in socials"
          :key="social.name"
          class="inline-block not-last:mr-8"
        >
          <a
            :aria-label="social.name"
            :href="social.url"
            rel="noreferrer"
            target="_blank"
            class="text-grey-4 dark:text-dark-ink-muted hover:text-red-1 transition-colors"
          >
            <AppSocialIcon :name="social.icon" :size="24" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import AppLabourLogo from '../logo/AppLabourLogo.vue'
import AppSocialIcon from '../icons/AppSocialIcon.vue'

import { ref, computed } from 'vue'

const year = computed(() => new Date().getFullYear())

const socials = ref([
  {
    name: 'Facebook',
    icon: 'facebook',
    url: 'https://www.facebook.com/labourparty',
  },
  {
    name: 'Instagram',
    icon: 'instagram',
    url: 'https://www.instagram.com/uklabour/',
  },
  {
    name: 'YouTube',
    icon: 'youtube',
    url: 'https://www.youtube.com/labourparty',
  },
  {
    name: 'X',
    icon: 'x',
    url: 'https://x.com/UKLabour',
  },
])
</script>

<style>
/* Lighten the Labour logo in dark mode so the grey (#666) fill stays visible
   on the dark surface. CSS fill overrides the SVG presentation attribute. */
.dark .footer-logo svg {
  fill: var(--color-dark-ink-muted);
}
</style>
